import { lazy } from 'react';

const Overview = lazy(() => import('../overviewPage'));

//accessed by normal users and peer analysis users
export const overviewRoutes = [
  {
    path: '/monthlyStarsOverview',
    component: Overview,
    menuType: 'monthlyStars',
    listName: 'monthlyStars',
  },
  {
    path: '/qualityImprovementOverview',
    component: Overview,
    menuType: 'qualityImprovement',
    listName: 'qualityImprovement',
  },
  {
    path: '/measureChampionOverview',
    component: Overview,
    menuType: 'measureChampion',
    listName: 'measureChampion',
  },
  {
    path: '/rewardFactorContentOverview',
    component: Overview,
    menuType: 'rewardFactor',
    listName: 'rewardFactor',
  },
  {
    path: '/qualityImprovementContentOverview',
    component: Overview,
    menuType: 'qualityImprovement',
    listName: 'qualityImprovement',
  },
  {
    path: '/leadershipTeamOverview',
    component: Overview,
    menuType: 'leadershipPackage',
    listName: 'leadershipPackage',
  },
  {
    path: '/weeklyRedFlagAnalysis',
    component: Overview,
    menuType: 'weeklyRedFlagAnalysis',
    listName: 'weeklyRedFlagAnalysis',
  },
  {
    path: '/multiContractOverview',
    component: Overview,
    menuType: 'multiContractViews',
    listName: 'multiContractViews',
  },
  {
    path: '/multiContractContentSummary',
    component: Overview,
    menuType: 'multiContractViews',
    listName: 'multiContractViews',
  },
  {
    path: '/peerAnalysisModel',
    component: Overview,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/additionalAnalysis',
    component: Overview,
    menuType: 'additionalAnalysis',
    listName: 'additionalAnalysis',
  },
];
